import demandForm from '@/view/demand/form'
import success from '@/view/demand/success'

const demandRouter = [
  {
    path: '/demand/add.html',
    name: 'add-demand-form',
    component: demandForm,
    meta: {
      title: '提交需求'
    }
  },
  {
    path: '/demand/success.html',
    name: 'demand-success',
    component: success,
    meta: {
      title: '河姆渡方案馆'
    }
  }
]

export default demandRouter



// WEBPACK FOOTER //
// ./src/router/demands/demand.js